import React, { useState, useEffect } from "react";
import { Button, FormGroup, Label, Input, Card, CardBody, CardHeader, Table } from "reactstrap";
import { Row, Col } from "reactstrap";
import { MdAdd, MdRemove } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { getVisitorTypeByPlace, getVisitorSubTypeByType, getVisitorSubSubTypeBySubType, getVisitorsCategories, getVisitorsSubCategories, getVisitorsSubSubCategories, getAllVisitorCategories, getVisitorDetailsByPlaceId } from "../../redux/actions/indexActions";
import AdditionalFormFields from "./AdditionalFormFields";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { Link } from "react-router-dom";
const VisitorForm = ({ ticketSubType, placeId }) => {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state.AuthReducer);
    const { indexReducer: { bookingCategoriesList, bookingSubCategoriesList, visitorDetailOfPlace, visitorTypeofPlace, visitorSubTypeListByType, visitorSubSubTypeListBySubType, visitorCategories,visitorCatList,visitorSubCatList,visitorSubSubCatList,editVisitorDetails} } = useSelector((state) => state);

    const [errors, setErrors] = useState({});
    const [isEdit, setIsEdit] = useState({cat:false,subCat:false,subSubCat:false});
    const [visitorDetails, setVisitorDetails] = useState(false);
    const [secVisitorDetails, setSecVisitorDetails] = useState(false);


    const [visitorDetail, setVisitorDetail] = useState({
        full_name: 0,
        age: 0,
        gender: 0,
        id_type: 0,
        id_no: 0,
        upload_capture: 0,
        country: 0,
        state: 0,
        address: 0,
        pin_code: 0,
        visitor_category_id: '',
        visitor_sub_category_id: '',
        visitor_sub_sub_category_id: '',
        booking_category_id: '',
        booking_sub_category_id: '',
        booking_sub_sub_category_id: '',
        is_attach_document: 0,
        additional_id: 0,
        id_number: 0,
        additionalFieldType: "",
        type: 'visitorDetails',
    });
    const [secVisitorDetail, setSecVisitorDetail] = useState({
        full_name: 0,
        age: 0,
        gender: 0,
        id_type: 0,
        id_no: 0,
        upload_capture: 0,
        country: 0,
        state: 0,
        address: 0,
        pin_code: 0,
        visitor_category_id: '',
        visitor_sub_category_id: '',
        visitor_sub_sub_category_id: '',
        booking_category_id: '',
        booking_sub_category_id: '',
        booking_sub_sub_category_id: '',
        is_attach_document: 0,
        additional_id: 0,
        id_number: 0,
        additionalFieldType: "",
        type: 'secondryVisitorDetails',
    });


    useEffect(() => {
        dispatch(getVisitorsCategories());
        dispatch(getAllVisitorCategories(placeId));
        dispatch(getVisitorDetailsByPlaceId(placeId));
    }, []);


    useEffect(() => {
        const vstrDtl = editVisitorDetails.filter((item => item?.type == "visitorDetails"));
        const secVstrDtl = editVisitorDetails.filter((item => item?.type == "secondryVisitorDetails"));
         if (vstrDtl[0]?.visitor_type_id != '') {
            dispatch(getVisitorSubTypeByType(auth.token,vstrDtl[0]?.visitor_type_id));
        }
        if (vstrDtl[0]?.visitor_sub_type_id != '') {
            dispatch(getVisitorSubSubTypeBySubType(auth.token,vstrDtl[0]?.visitor_sub_type_id));
        }
        setVisitorDetail((prev) => ({
            ...prev,
            id: vstrDtl?.[0]?.id ?? '',
            full_name: vstrDtl?.[0]?.full_name ?? 0,
            age: vstrDtl?.[0]?.age ?? 0,
            gender: vstrDtl?.[0]?.gender ?? 0,
            id_type: vstrDtl?.[0]?.id_type ?? 0,
            id_no: vstrDtl?.[0]?.id_no ?? 0,
            upload_capture: vstrDtl?.[0]?.upload_capture ?? 0,
            country: vstrDtl?.[0]?.country ?? 0,
            state: vstrDtl?.[0]?.state ?? 0,
            address: vstrDtl?.[0]?.address ?? 0,
            pin_code: vstrDtl?.[0]?.pincode ?? 0,
            visitor_category_id: vstrDtl?.[0]?.visitor_type_id ?? '',
            visitor_sub_category_id: vstrDtl?.[0]?.visitor_sub_type_id ?? '',
            visitor_sub_sub_category_id: vstrDtl?.[0]?.visitor_sub_sub_type_id ?? '',
            booking_category_id: vstrDtl?.[0]?.booking_category_id ?? '',
            booking_sub_category_id: vstrDtl?.[0]?.booking_sub_category_id ?? '',
            booking_sub_sub_category_id: vstrDtl?.[0]?.booking_sub_sub_category_id ?? '',
            is_attach_document: vstrDtl?.[0]?.is_attach_document ?? false,
            additional_id: vstrDtl?.[0]?.additional_id ?? 0,
            id_number: vstrDtl?.[0]?.id_number ?? 0,
            additionalFieldType: vstrDtl?.[0]?.additionalFieldType ?? '',
            type: vstrDtl?.[0]?.type ?? 'visitorDetails',
        }));
        setSecVisitorDetail((prev) => ({
            ...prev,
            id: secVstrDtl?.[0]?.id ?? '',
            full_name: secVstrDtl?.[0]?.full_name ?? 0,
            age: secVstrDtl?.[0]?.age ?? 0,
            gender: secVstrDtl?.[0]?.gender ?? 0,
            id_type: secVstrDtl?.[0]?.id_type ?? 0,
            id_no: secVstrDtl?.[0]?.id_no ?? 0,
            upload_capture: secVstrDtl?.[0]?.upload_capture ?? 0,
            country: secVstrDtl?.[0]?.country ?? 0,
            state: secVstrDtl?.[0]?.state ?? 0,
            address: secVstrDtl?.[0]?.address ?? 0,
            pin_code: secVstrDtl?.[0]?.pincode ?? 0,
            visitor_category_id: secVstrDtl?.[0]?.visitor_type_id ?? '',
            visitor_sub_category_id: secVstrDtl?.[0]?.visitor_sub_type_id ?? '',
            visitor_sub_sub_category_id: secVstrDtl?.[0]?.visitor_sub_sub_type_id ?? '',
            booking_category_id: secVstrDtl?.[0]?.booking_category_id ?? '',
            booking_sub_category_id: secVstrDtl?.[0]?.booking_sub_category_id ?? '',
            booking_sub_sub_category_id: secVstrDtl?.[0]?.booking_sub_sub_category_id ?? '',
            is_attach_document: secVstrDtl?.[0]?.is_attach_document ?? false,
            additional_id: secVstrDtl?.[0]?.additional_id ?? 0,
            id_number: secVstrDtl?.[0]?.id_number ?? 0,
            additionalFieldType: secVstrDtl?.[0]?.additionalFieldType ?? '',
            type: secVstrDtl?.[0]?.type ?? 'secondryVisitorDetails',
        }));
        setVisitorDetails(vstrDtl?.[0]?.is_visitorDetails == 1 ? true:false);
        setSecVisitorDetails(secVstrDtl?.[0]?.is_secVisitorDetails == 1 ? true:false);
    },[editVisitorDetails])

        useEffect(() => {
    }, [secVisitorDetail]);

    useEffect(() => {
        if (!visitorCategories) {
            dispatch(getVisitorsCategories());
        }
        if (visitorDetail.visitor_category_id != '') {
            dispatch(getVisitorsSubCategories(visitorDetail.visitor_category_id));
        }
        if (visitorDetail.visitor_category_id != '' && visitorDetail.visitor_sub_category_id != '') {
            dispatch(getVisitorsSubSubCategories(visitorDetail.visitor_category_id, visitorDetail.visitor_sub_category_id));
        }
    }, [visitorDetail.visitor_category_id, visitorDetail.visitor_sub_category_id]);

    useEffect(() => {
        if (!visitorCategories) {
            dispatch(getVisitorsCategories());
        }
        if (secVisitorDetail.visitor_category_id != '') {
            dispatch(getVisitorsSubCategories(secVisitorDetail.visitor_category_id));
        }
        if (secVisitorDetail.visitor_category_id != '' && secVisitorDetail.visitor_sub_category_id != '') {
            dispatch(getVisitorsSubSubCategories(secVisitorDetail.visitor_category_id, secVisitorDetail.visitor_sub_category_id));
        }
    }, [secVisitorDetail.visitor_category_id, secVisitorDetail.visitor_sub_category_id]);

    useEffect(() => {
        dispatch(getVisitorTypeByPlace(auth.token, placeId));
    }, [dispatch, auth.token, placeId]);

    // useEffect(() => {
    //     if (visitorDetailOfPlace) {
    //         setVisitorDetail(prevState => ({
    //             ...prevState,
    //             ...visitorDetailOfPlace
    //         }));
    //     } else {
    //         setVisitorDetail(prevState => ({
    //             ...prevState,
    //             additionalField: 0,
    //             subAdditionalField: 0,
    //             subSubAdditionalField: 0,
    //             groupBookingType: 0,
    //             subGroupBookingType: 0,
    //             subSubGroupBookingType: 0,
    //             is_attach_document: 0,
    //             additionalFieldType: "",
    //             additional_field_id: "",
    //             sub_additional_field_id: "",
    //             group_booking_type: "",
    //             sub_group_booking_type: "",
    //             sub_sub_group_booking_type: "",
    //             full_name: 0,
    //             age: 0,
    //             gender: 0,
    //             id_type: 0,
    //             id_no: 0,
    //             upload_capture: 0,
    //             country: 0,
    //             state: 0,
    //             address: 0,
    //             place_id: placeId,
    //             pin_code: 0,
    //         }));
    //     }
    // }, [visitorDetailOfPlace])

    const [bookingAttackDocuments, setBookingAttackDocuments] = useState([{ name: '', file: '', link: '' }]);
    const addBookingAttackDocuments = () => {
        setBookingAttackDocuments((prev) => [...prev, { name: '', file: '', link: '' }]);
    };
    const removeBookingAttackDocuments = (index) => {
        if (bookingAttackDocuments.length > 1) {
            setBookingAttackDocuments((prev) => prev.filter((_, i) => i !== index));
        }
    };

    const [VisitorTypeId, SetVisitorTypeId] = useState(0);
    const [VisitorType, SetVisitorType] = useState("");
    const [VisitorSubTypeId, setVisitorSubTypeId] = useState(0);
    const [VisitorSubSubTypeId, setVisitorSubSubTypeId] = useState(0);
    const [VisitorSubType, setVisitorSubType] = useState([{id:'', visitor_sub_type: '' }]);
    const [SubVisitorSubType, setSubVisitorSubType] = useState([{ id:'',sub_visitor_sub_type: "" }]);

    const HandleVisitorType = (e) => {
        const { value } = e.target;
        dispatch(getVisitorSubTypeByType(auth.token, value));
        SetVisitorTypeId(value);
        setVisitorDetail(prevState => ({
            ...prevState,
            visitor_category_id: value,
        }));
        setSecVisitorDetail(prevState => ({
            ...prevState,
            visitor_category_id: value,
        }));
    };

    const addService = () => {
        setVisitorSubType([...VisitorSubType, { visitor_sub_type: '' }]);
    };
    const removeService = (index) => {
        const updatedVisitorSubType = VisitorSubType.filter((_, i) => i !== index);
        setVisitorSubType(updatedVisitorSubType);
    };
    const inputServiceHandler = (e, index) => {
        const { name, value } = e.target;
        const updatedVisitorSubType = [...VisitorSubType];
        updatedVisitorSubType[index][name] = value;
        setVisitorSubType(updatedVisitorSubType);
        setVisitorDetail(prevState => ({
            ...prevState,
            visitor_sub_category_id: value,
        }));
    };
    const addSubVisitorSubTypeBox = () => {
        const updatedSubType = [...SubVisitorSubType];
        updatedSubType.push({ sub_visitor_sub_type: "" });
        setSubVisitorSubType(updatedSubType);
    };
    const VisitorSubTypeHandler = (e) => {
        const { value } = e.target;
        setVisitorSubTypeId(value);
        dispatch(getVisitorSubSubTypeBySubType(auth.token, value));
        setVisitorDetail(prevState => ({
            ...prevState,
            visitor_sub_category_id: value,
        }));
        setSecVisitorDetail(prevState => ({
            ...prevState,
            visitor_sub_category_id: value,
        }));
    };

    const VisitorSubSubTypeHandler = (e) => {
        const { value } = e.target;
        setVisitorSubSubTypeId(value);
        setVisitorDetail(prevState => ({
            ...prevState,
            visitor_sub_sub_category_id: value,
        }));
        setSecVisitorDetail(prevState => ({
            ...prevState,
            visitor_sub_sub_category_id: value,
        }));
    };

    const handleVisitorTypeSubmit = () => {
        if (!VisitorType || !placeId) {
            toast.error("Both Place visitor and Place are required");
            return;
        }
        const VisitorTypeForm = new FormData();
        VisitorTypeForm.append("visitor_type", VisitorType);
        VisitorTypeForm.append("place_id", placeId);
        VisitorTypeForm.append("id", VisitorTypeId);
        VisitorTypeForm.append("status", 1);
        axios.post(`/api/admin/v1/addUpdate-place-tourist-type`, VisitorTypeForm, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message || "Place visitor added successfully!");
            dispatch(getAllVisitorCategories(placeId));
            dispatch(getVisitorTypeByPlace(auth.token, placeId));
            SetVisitorType("");
            SetVisitorTypeId(0);
            setIsEdit(prev => ({
                ...prev,
                cat:false,
            }));
            setErrors({});
        }).catch((err) => {
            const errorMessage = err.response?.data?.message || "An error occurred";
            toast.error(errorMessage);
            setErrors(err.response?.data || {});
        });
    };
    const handleVisitorSubTypeSubmit = () => {
        if (!VisitorTypeId) {
            toast.error("visitor ID is required.");
            return;
        }
        if (!Array.isArray(VisitorSubType) || VisitorSubType.length === 0 || VisitorSubType.some(sz => !sz.visitor_sub_type.trim())) {
            toast.error("valid sub-visitor  required.");
            return;
        }
        const VisitorTypeForm = new FormData();
        VisitorTypeForm.append("visitor_id", VisitorTypeId);
        VisitorTypeForm.append("visitor_sub_type", JSON.stringify(VisitorSubType));
        axios.post(`/api/admin/v1/addUpdate-sub-visitor-type`, VisitorTypeForm, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message || "Sub-visitor added successfully.");
            dispatch(getAllVisitorCategories(placeId));
            setVisitorSubTypeId(0);
            setVisitorSubType([{id:'', visitor_sub_type: '' }]);
            setIsEdit(prev => ({
                ...prev,
                subCat:false,
            }));
            dispatch({
                type: "ADD_VISITOR_SUB_TYPE_BY_TYPE_FULFILLED",
                payload: res.data?.data,
              });
        }).catch((err) => {
            const errorMessage = err.response?.data?.message || "An error occurred";
            toast.error(errorMessage);

            if (err.response?.data?.errors) {
                setErrors(err.response.data.errors);
            } else {
                setErrors({ general: errorMessage });
            }
        });
    };
    const inputSubVisitorSubTypeHandler = (e, subSubIndex) => {
        const { name, value } = e.target;
        const updatedSubType = [...SubVisitorSubType];
        updatedSubType[subSubIndex][name] = value;
        setSubVisitorSubType(updatedSubType);
    };
    const removeSubVisitorSubType = (subSubIndex) => {
        setSubVisitorSubType(SubVisitorSubType.filter((_, i) => i !== subSubIndex));
    };
    const handleSubmitVisitorSubSubType = () => {
        const errors = {};
        if (!VisitorSubTypeId) errors.VisitorSubTypeId = "Sub visitor is required";

        if (!SubVisitorSubType || !Array.isArray(SubVisitorSubType) || SubVisitorSubType.length === 0) {
            errors.SubVisitorSubType = "At least one Sub-Sub visitor is required";
        } else {
            SubVisitorSubType.forEach((sub, index) => {
                if (!sub.sub_visitor_sub_type.trim()) {
                    errors[`SubVisitorSubType_${index}`] = `Sub-Sub visitor at index ${index + 1} is required`;
                }
            });
        }
        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            Object.values(errors).forEach((error) => toast.error(error));
            return;
        }
        const form = new FormData();
        form.append("visitor_sub_type_id", VisitorSubTypeId);
        form.append("visitor_sub_sub_type", JSON.stringify(SubVisitorSubType));
        axios.post(`/api/admin/v1/addUpdate-sub-sub-visitor-type`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
            dispatch({
                type: "ADD_VISITOR_SUB_SUB_TYPE_BY_TYPE_FULFILLED",
                payload: res.data?.data,
              });
            setSubVisitorSubType([{ id:"",sub_visitor_sub_type: "" }]);
            dispatch(getAllVisitorCategories(placeId));
            setIsEdit(prev => ({
                ...prev,
                subSubCat:false,
            }));
            setErrors({});
        }).catch((err) => {
            toast.error(err.response.data?.message || "An error occurred");
            setErrors(err.response.data);
        });
    };

    const handleSubmitVisitorForm = () => {

        if (!placeId) {
            toast.error("Place ID is required.");
            return;
        }
        const combinedData = [visitorDetail, secVisitorDetail];
        const form = new FormData();
        combinedData.forEach((obj, index) => {
            for (const key in obj) {
                form.append(`data[${index}][${key}]`, obj[key]);
            }
        });
        form.append("place_id", placeId);
        form.append("is_visitorDetails", (visitorDetails === true) ? 1 : 0);
        form.append("is_secVisitorDetails", (secVisitorDetails === true) ? 1 : 0);
        axios.post(`/api/admin/v1/add-visitor-details`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            dispatch(getVisitorDetailsByPlaceId(placeId));
            toast.success(res.data?.message);
        }).catch((err) => {
            if (err.response) {
                const errorMessage = err.response.data?.message || "An error occurred";
                toast.error(errorMessage);
                setErrors(err.response.data);
            } else if (err.request) {
                toast.error("No response from server. Please check your connection.");
            } else {
                toast.error("An unexpected error occurred.");
            }
        });
    };

      const handleVisitorCatDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete ?")) {
        axios
            .delete(`/api/admin/v1/tourist-type-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllVisitorCategories(placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    const handleVisitorCatSubDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete ?")) {
        axios
            .delete(`/api/admin/v1/tourist-sub-type-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllVisitorCategories(placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    const handleVisitorCatSubSubDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete ?")) {
        axios
            .delete(`/api/admin/v1/tourist-sub-sub-type-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllVisitorCategories(placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    useEffect(() => {
    },[visitorCatList,visitorSubCatList,visitorSubSubCatList])

    return (
        <div className="container bg-white p-4 rounded shadow-lg">
            <Row>
                <Col md={12}>
                    <Label className="d-flex align-items-center">
                        <h4 className="text-right text-black"> Visitor Category </h4>
                    </Label>
                </Col>
                <Card className="mb-4 shadow-sm">
                    <CardBody>
                        <div className="row align-items-center mb-3">
                            <div className="col-md-6">
                                <FormGroup>
                                    <Label className="fw-bold">Visitor <span className="text-danger">*</span></Label>
                                    <Input type="text" name="visitor_type" value={VisitorType} onChange={(e) => SetVisitorType(e.target.value)} placeholder="Enter visitor Name" />
                                    {errors?.visitor_name && (
                                        <span className="d-block text-danger mt-1">{errors.visitor_name}</span>
                                    )}
                                </FormGroup>
                            </div>
                            <div className="col-md-3 mt-2 text-md-end text-center">
                                {isEdit.cat ? (
                                    <Button className="bg-success text-white px-4" size="sm" onClick={handleVisitorTypeSubmit}>Update Place Visitor</Button>  
                                ):(
                                    <Button className="bg-success text-white px-4" size="sm" onClick={handleVisitorTypeSubmit}>+ Add Place Visitor</Button>
                                )}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <Label className="fw-bold">Place Visitor <span className="text-danger">*</span></Label>
                                    {isEdit.subCat != true && (
                                    <Button className="bg-success text-white" size="sm" onClick={addService}>
                                        <MdAdd size={22} /> Add Sub Visitor
                                    </Button>
                                    )}
                                </div>
                                <FormGroup>
                                    <Input type="select" name="visitor_id" value={VisitorTypeId} onChange={HandleVisitorType}>
                                        <option value="">Select Visitor</option>
                                        {visitorTypeofPlace?.filter((item, index, self) => 
                                            index === self.findIndex((t) => t.id === item.id)
                                        ).map((item) => (
                                            <option key={item.id} value={item.id}>{item.visitor_type}</option>
                                        ))}
                                    </Input>
                                    {errors?.place_id && (
                                        <span className="d-block text-danger mt-1">{errors.place_id}</span>
                                    )}
                                </FormGroup>
                                {VisitorSubType.map((service, index) => (
                                    <div className="d-flex align-items-center rounded my-2 bg-light" key={index}>
                                        <Input type="text" name="visitor_sub_type" value={service.visitor_sub_type || ""} onChange={(e) => inputServiceHandler(e, index)} placeholder="Enter Sub Visitor" />
                                        {isEdit.subCat != true && (
                                        <Button className="bg-danger text-white" size="sm" onClick={() => removeService(index)}>
                                            <MdRemove size={22} />
                                        </Button>
                                        )}
                                    </div>
                                ))}
                                <div className="text-center mt-3">
                                    {isEdit.subCat ? (
                                        <Button color="primary" size="sm" onClick={handleVisitorSubTypeSubmit}>Update Sub Visitor</Button>
                                    ):(
                                        <Button color="primary" size="sm" onClick={handleVisitorSubTypeSubmit}>Add Sub Visitor</Button>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <Label className="fw-bold">
                                        Select Sub Visitor  <span className="text-danger">*</span>
                                    </Label>
                                    {isEdit.subSubCat != true && (
                                        <Button className="bg-success text-white" size="sm" onClick={addSubVisitorSubTypeBox}>
                                            <MdAdd size={22} /> Add Sub Sub Visitor
                                        </Button>
                                    )}
                                </div>
                                <FormGroup>
                                    <Input type="select" name="visitor_sub_type"  value={VisitorSubTypeId} onChange={VisitorSubTypeHandler}>
                                        <option value="">Select Sub Visitor</option>
                                        {visitorSubTypeListByType?.filter((item, index, self) => 
                                            index === self.findIndex((t) => t.id === item.id)
                                        ).map((item) => (
                                            <option key={item.id} value={item.id}>{item.visitor_sub_type}</option>
                                        ))}
                                    </Input>
                                    <span className="text-danger">{errors?.tourist_type}</span>
                                </FormGroup>
                                {Array.isArray(SubVisitorSubType) &&
                                    SubVisitorSubType.map((service, SubVisitorSubTypeIndex) => (
                                        <div className="d-flex align-items-center rounded my-2 bg-light" key={SubVisitorSubTypeIndex}>
                                            <Input type="text" name="sub_visitor_sub_type" value={service.sub_visitor_sub_type || ""} onChange={(e) => inputSubVisitorSubTypeHandler(e, SubVisitorSubTypeIndex)} placeholder="Enter Sub Sub Visitor" />
                                            {isEdit.subSubCat != true && (
                                                <Button className="bg-danger text-white" size="sm" onClick={() => removeSubVisitorSubType(SubVisitorSubTypeIndex)}>
                                                    <MdRemove size={22} />
                                                </Button>
                                            )}
                                        </div>
                                    ))}
                                <div className="text-center mt-3">
                                    {isEdit.subSubCat ? (
                                        <Button color="primary" size="sm" onClick={handleSubmitVisitorSubSubType}>
                                            Update Sub Sub Visitor
                                        </Button>
                                    ):(
                                        <Button color="primary" size="sm" onClick={handleSubmitVisitorSubSubType}>
                                            Add Sub Sub Visitor
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Row>
            <Row>
                <Col md={12} className="mt-5">
                    <Label className="d-flex align-items-center">
                        <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" checked={visitorDetails} onChange={(e) => setVisitorDetails(e.target.checked)} />
                        </div>
                        <h4 className="text-right text-black">Visitor Details</h4>
                    </Label>
                </Col>
                {visitorDetails && (
                    <>
                        <Col md={12}>
                            <Row>
                                <Col md={4}>
                                    <div className="mb-3">
                                        <Input type="select" name="visitor_category_id"
                                            value={visitorDetail.visitor_category_id} onChange={HandleVisitorType}>
                                            <option value="">Visitor Type</option>
                                            {visitorTypeofPlace?.filter((item, index, self) => 
                                                index === self.findIndex((t) => t.id === item.id)
                                            ).map((item) => (
                                                <option key={item.id} value={item.id}>{item.visitor_type}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="mb-3">
                                        <Input type="select" name="visitor_sub_category_id" value={visitorDetail.visitor_sub_category_id} onChange={VisitorSubTypeHandler}>
                                            <option value="">Select Sub Visitor</option>
                                            {visitorSubTypeListByType?.filter((item, index, self) => 
                                                index === self.findIndex((t) => t.id === item.id)
                                            ).map((item) => (
                                                <option key={item.id} value={item.id}>{item.visitor_sub_type}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="mb-3">
                                        <Input type="select" name="visitor_sub_sub_category_id" value={visitorDetail.visitor_sub_sub_category_id} onChange={VisitorSubSubTypeHandler}>
                                            <option value="">Select Sub Sub Visitor</option>
                                            {visitorSubSubTypeListBySubType?.filter((item, index, self) => 
                                                index === self.findIndex((t) => t.id === item.id)
                                            ).map((item) => (
                                                <option key={item.id} value={item.id}>{item.visitor_sub_sub_type}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <FormGroup className="d-flex align-items-center">
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={visitorDetail.full_name == 1}
                                                onChange={(e) => {
                                                    setVisitorDetail(prev => ({
                                                        ...prev,
                                                        full_name: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Full Name
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={visitorDetail.age == 1}
                                                onChange={(e) => {
                                                    setVisitorDetail(prev => ({
                                                        ...prev,
                                                        age: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Age
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={visitorDetail.gender == 1}
                                                onChange={(e) => {
                                                    setVisitorDetail(prev => ({
                                                        ...prev,
                                                        gender: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Gender
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={visitorDetail.country == 1}
                                                onChange={(e) => {
                                                    setVisitorDetail(prev => ({
                                                        ...prev,
                                                        country: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Country
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={visitorDetail.state == 1}
                                                onChange={(e) => {
                                                    setVisitorDetail(prev => ({
                                                        ...prev,
                                                        state: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            State
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={visitorDetail.address == 1}
                                                onChange={(e) => {
                                                    setVisitorDetail(prev => ({
                                                        ...prev,
                                                        address: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Address
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={visitorDetail.pin_code == 1}
                                                onChange={(e) => {
                                                    setVisitorDetail(prev => ({
                                                        ...prev,
                                                        pin_code: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Pin Code
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                        {/* <Col md={4}>
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox"
                                        checked={visitorDetail.booking_category_id == 1}
                                        onChange={(e) => {
                                            setVisitorDetail(prev => ({
                                                ...prev,
                                                booking_category_id: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="me-2" />
                                    Booking Category
                                </Label>
                            </FormGroup>
                            {visitorDetail.booking_category_id == 1 && (
                                <>
                                    <div className="mb-3">
                                        <Input type="select" name="place_id"
                                            value={visitorDetail.booking_category_id}
                                            onChange={(e) =>
                                                setVisitorDetail((prev) => ({
                                                    ...prev,
                                                    booking_category_id: e.target.value,
                                                }))
                                            }>
                                            <option value="">Select Field Type</option>
                                            {ticketSubType?.map((item) => (
                                                <option key={item.id} value={item.id}>{item.sub_type}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </>
                            )}
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox"
                                        checked={visitorDetail.booking_sub_category_id == 1}
                                        onChange={(e) => {
                                            setVisitorDetail(prev => ({
                                                ...prev,
                                                booking_sub_category_id: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="me-2" />
                                    Booking Sub Category
                                </Label>
                            </FormGroup>
                            {visitorDetail.booking_sub_category_id == 1 && visitorDetail.booking_sub_category_id == 1 && (
                                <>
                                    <div className="mb-3">
                                        <Input type="select" name="place_id"
                                            value={visitorDetail.booking_sub_category_id}
                                            onChange={(e) =>
                                                setVisitorDetail((prev) => ({
                                                    ...prev,
                                                    booking_sub_category_id: e.target.value,
                                                }))
                                            }>
                                            <option value="">Select Sub Field Type</option>
                                            {bookingCategoriesList?.map((item) => (
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </>
                            )}
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox"
                                        checked={visitorDetail.booking_sub_sub_category_id == 1}
                                        onChange={(e) => {
                                            setVisitorDetail(prev => ({
                                                ...prev,
                                                booking_sub_sub_category_id: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="me-2" />
                                    Booking Sub Sub Category
                                </Label>
                            </FormGroup>
                            {visitorDetail.booking_sub_sub_category_id == 1 && visitorDetail.booking_sub_sub_category_id == 1 && visitorDetail.booking_sub_sub_category_id == 1 && (
                                <>
                                    <div className="mb-3">
                                        <Input type="select" name="place_id"
                                            value={visitorDetail.booking_sub_sub_category_id}
                                            onChange={(e) =>
                                                setVisitorDetail((prev) => ({
                                                    ...prev,
                                                    booking_sub_sub_category_id: e.target.value,
                                                }))
                                            }>
                                            <option value="">Select Sub Sub Field Type</option>
                                            {bookingSubCategoriesList?.map((item) => (
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </>
                            )}
                        </Col> */}
                        <Col md={12} className="mt-3">
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox" checked={visitorDetail.is_attach_document == 1} onChange={(e) => {
                                        setVisitorDetail(prev => ({
                                            ...prev,
                                            is_attach_document: e.target.checked ? 1 : 0
                                        }));
                                    }} className="me-2" />
                                    Attach Document
                                </Label>
                            </FormGroup>
                            {/*visitorDetail.is_attach_document == 1 && (
                                <>
                                    {bookingAttackDocuments?.map((field, i) => (
                                        <div className="d-flex align-items-center mb-3" key={i}>
                                            <Input type="text" placeholder="Field Name" value={field.name} className="me-2" />

                                            <Input type="file" value={field.file} className="me-2" />

                                            <Input type="text" placeholder="Link" value={field.link} className="me-2" />
                                            <Button className="ms-1" color="primary" onClick={addBookingAttackDocuments}>
                                                +
                                            </Button>
                                            <Button className="ms-1" color="danger" onClick={() => removeBookingAttackDocuments(i)}>
                                                -
                                            </Button>
                                        </div>
                                    ))}
                                </>
                            )*/}
                        </Col>
                        <Col md={12}>
                            <FormGroup className="d-flex align-items-center">
                                <Label className="d-flex align-items-center m-1">
                                    <Input type="checkbox"
                                        checked={visitorDetail.additional_id == 1}
                                        onChange={(e) => {
                                            setVisitorDetail(prev => ({
                                                ...prev,
                                                additional_id: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="m-1" />
                                    Additional ID
                                </Label>
                                <Label className="d-flex align-items-center m-1">
                                    <Input type="checkbox"
                                        checked={visitorDetail.id_number == 1}
                                        onChange={(e) => {
                                            setVisitorDetail(prev => ({
                                                ...prev,
                                                id_number: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="m-1" />
                                    ID Number
                                </Label>
                                <Label className="d-flex align-items-center m-1">
                                    <Input type="checkbox"
                                        checked={visitorDetail.upload_capture == 1}
                                        onChange={(e) => {
                                            setVisitorDetail(prev => ({
                                                ...prev,
                                                upload_capture: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="m-1" />
                                    Upload / Capture ID
                                </Label>
                            </FormGroup>
                        </Col>
                    </>
                )}
            </Row>
            <Row>
                <Col md={12} className="mt-5">
                    <Label className="d-flex align-items-center">
                        <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox"
                                checked={secVisitorDetails}
                                onChange={(e) => setSecVisitorDetails(e.target.checked)}
                            />
                        </div>
                        <h4 className="text-right text-black">Secondary Visitor Details</h4>
                    </Label>
                </Col>
                {secVisitorDetails && (
                    <>
                        <Col md={12}>
                            <Row>
                                <Col md={4}>
                                    <div className="mb-3">
                                        <Input type="select" name="visitor_category_id"
                                            value={secVisitorDetail.visitor_category_id} onChange={HandleVisitorType}>
                                            <option value="">Visitor Type</option>
                                            {visitorTypeofPlace?.filter((item, index, self) => 
                                                index === self.findIndex((t) => t.id === item.id)
                                            ).map((item) => (
                                                <option key={item.id} value={item.id}>{item.visitor_type}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="mb-3">
                                        <Input type="select" name="visitor_sub_category_id" value={secVisitorDetails.visitor_sub_category_id}
                                        onChange={VisitorSubTypeHandler}>
                                            <option value="">Select Sub Visitor</option>
                                            {visitorSubTypeListByType?.filter((item, index, self) => 
                                                index === self.findIndex((t) => t.id === item.id)
                                            ).map((item) => (
                                                <option key={item.id} value={item.id}>{item.visitor_sub_type}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="mb-3">
                                        <Input type="select" name="visitor_sub_sub_category_id" value={secVisitorDetails.visitor_sub_sub_category_id}
                                         onChange={VisitorSubSubTypeHandler}>
                                            <option value="">Select Sub Visitor</option>
                                            {visitorSubSubTypeListBySubType?.filter((item, index, self) => 
                                                index === self.findIndex((t) => t.id === item.id)
                                            ).map((item) => (
                                                <option key={item.id} value={item.id}>{item.visitor_sub_sub_type}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <FormGroup className="d-flex align-items-center">
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={secVisitorDetail.full_name == 1}
                                                onChange={(e) => {
                                                    setSecVisitorDetail(prev => ({
                                                        ...prev,
                                                        full_name: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Full Name
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={secVisitorDetail.age == 1}
                                                onChange={(e) => {
                                                    setSecVisitorDetail(prev => ({
                                                        ...prev,
                                                        age: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Age
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={secVisitorDetail.gender == 1}
                                                onChange={(e) => {
                                                    setSecVisitorDetail(prev => ({
                                                        ...prev,
                                                        gender: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Gender
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={secVisitorDetail.country == 1}
                                                onChange={(e) => {
                                                    setSecVisitorDetail(prev => ({
                                                        ...prev,
                                                        country: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Country
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={secVisitorDetail.state == 1}
                                                onChange={(e) => {
                                                    setSecVisitorDetail(prev => ({
                                                        ...prev,
                                                        state: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            State
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={secVisitorDetail.address == 1}
                                                onChange={(e) => {
                                                    setSecVisitorDetail(prev => ({
                                                        ...prev,
                                                        address: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Address
                                        </Label>
                                        <Label className="d-flex align-items-center m-1">
                                            <Input type="checkbox"
                                                checked={secVisitorDetail.pin_code == 1}
                                                onChange={(e) => {
                                                    setSecVisitorDetail(prev => ({
                                                        ...prev,
                                                        pin_code: e.target.checked ? 1 : 0
                                                    }));
                                                }}
                                                className="m-1" />
                                            Pin Code
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                        {/* <Col md={4}>
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox"
                                        checked={secVisitorDetail.groupBookingType == 1}
                                        onChange={(e) => {
                                            setSecVisitorDetail(prev => ({
                                                ...prev,
                                                groupBookingType: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="me-2" />
                                    Booking Category
                                </Label>
                            </FormGroup>
                            {secVisitorDetail.groupBookingType == 1 && (
                                <>
                                    <div className="mb-3">
                                        <Input type="select" name="place_id"
                                            value={secVisitorDetail.additionalFieldType}
                                            onChange={(e) =>
                                                setSecVisitorDetail((prev) => ({
                                                    ...prev,
                                                    additionalFieldType: e.target.value,
                                                }))
                                            }
                                        >
                                            <option value="">Select Field Type</option>
                                            {ticketSubType?.map((item) => (
                                                <option key={item.id} value={item.id}>{item.sub_type}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </>
                            )}
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox"
                                        checked={secVisitorDetail.subGroupBookingType == 1}
                                        onChange={(e) => {
                                            setSecVisitorDetail(prev => ({
                                                ...prev,
                                                subGroupBookingType: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="me-2" />
                                    Booking Sub Category
                                </Label>
                            </FormGroup>
                            {secVisitorDetail.subGroupBookingType == 1 && secVisitorDetail.groupBookingType == 1 && (
                                <>
                                    <div className="mb-3">
                                        <Input type="select" name="place_id"
                                            value={secVisitorDetail.additional_field_id}
                                            onChange={(e) =>
                                                setSecVisitorDetail((prev) => ({
                                                    ...prev,
                                                    additional_field_id: e.target.value,
                                                }))
                                            }>
                                            <option value="">Select Sub Field Type</option>
                                            {bookingCategoriesList?.map((item) => (
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </>
                            )}
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox"
                                        checked={secVisitorDetail.subSubGroupBookingType == 1}
                                        onChange={(e) => {
                                            setSecVisitorDetail(prev => ({
                                                ...prev,
                                                subSubGroupBookingType: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="me-2" />
                                    Booking Sub Sub Category
                                </Label>
                            </FormGroup>
                            {secVisitorDetail.subSubGroupBookingType == 1 && secVisitorDetail.subGroupBookingType == 1 && secVisitorDetail.groupBookingType == 1 && (
                                <>
                                    <div className="mb-3">
                                        <Input type="select" name="place_id"
                                            value={secVisitorDetail.sub_additional_field_id}
                                            onChange={(e) =>
                                                setSecVisitorDetail((prev) => ({
                                                    ...prev,
                                                    sub_additional_field_id: e.target.value,
                                                }))
                                            }>
                                            <option value="">Select Sub Sub Field Type</option>
                                            {bookingSubCategoriesList?.map((item) => (
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </>
                            )}
                        </Col> */}
                        <Col md={12} className="mt-3">
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox"
                                        checked={secVisitorDetail.is_attach_document == 1}
                                        onChange={(e) => {
                                            setSecVisitorDetail(prev => ({
                                                ...prev,
                                                is_attach_document: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="me-2" />
                                    Attach Document
                                </Label>
                            </FormGroup>
                            {/* {secVisitorDetail.is_attach_document == 1 && (
                                <>
                                    {bookingAttackDocuments?.map((field, i) => (
                                        <div className="d-flex align-items-center mb-3" key={i}>
                                            <Input type="text" placeholder="Field Name" value={field.name} className="me-2" />
                                            <Input type="file" value={field.file} className="me-2" />
                                            <Input type="text" placeholder="Link" value={field.link} className="me-2" />
                                            <Button className="ms-1" color="primary" onClick={addBookingAttackDocuments}>
                                                +
                                            </Button>
                                            <Button className="ms-1" color="danger" onClick={() => removeBookingAttackDocuments(i)}>
                                                -
                                            </Button>
                                        </div>
                                    ))}
                                </>
                            )} */}
                        </Col>
                        <Col md={12}>
                            <FormGroup className="d-flex align-items-center">
                                <Label className="d-flex align-items-center m-1">
                                    <Input type="checkbox"
                                        checked={secVisitorDetail.additional_id == 1}
                                        onChange={(e) => {
                                            setSecVisitorDetail(prev => ({
                                                ...prev,
                                                additional_id: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="m-1" />
                                    Additional ID
                                </Label>
                                <Label className="d-flex align-items-center m-1">
                                    <Input type="checkbox"
                                        checked={secVisitorDetail.id_number == 1}
                                        onChange={(e) => {
                                            setSecVisitorDetail(prev => ({
                                                ...prev,
                                                id_number: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="m-1" />
                                    ID Number
                                </Label>
                                <Label className="d-flex align-items-center m-1">
                                    <Input type="checkbox"
                                        checked={secVisitorDetail.upload_capture == 1}
                                        onChange={(e) => {
                                            setSecVisitorDetail(prev => ({
                                                ...prev,
                                                upload_capture: e.target.checked ? 1 : 0
                                            }));
                                        }}
                                        className="m-1" />
                                    Upload / Capture ID
                                </Label>
                            </FormGroup>
                        </Col>
                    </>
                )}
            </Row>
            <AdditionalFormFields addFormType={'visitorForm'} placeId={placeId}/>
            <Row>
                <Col md={4} className="mt-3">
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white">
                            <h6 className="mb-0">Ticket Type</h6>
                        </CardHeader>
                        <CardBody>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Visitor Type</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {visitorCatList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.visitor_type}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <AiOutlineEdit
                                                    size={22}
                                                    className="text-warning me-3"
                                                    onClick={() => {
                                                        SetVisitorType(item?.visitor_type);
                                                        SetVisitorTypeId(item?.id);
                                                        setIsEdit(prev => ({
                                                            ...prev,
                                                            cat:true,
                                                        }));
                                                    }}
                                                    />
                                                <AiOutlineDelete
                                                    size={22}
                                                    className="text-danger"
                                                    onClick={() => handleVisitorCatDel(item.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={4} className="mt-3">
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white">
                            <h6 className="mb-0">Ticket Sub Type</h6>
                        </CardHeader>
                        <CardBody>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Visitor Type</th>
                                        <th>Visitor Sub Type</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {visitorSubCatList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.touristType?.visitor_type}</td>
                                        <td>{item?.visitor_sub_type}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <AiOutlineEdit
                                                size={22}
                                                className="text-warning me-3"
                                                onClick={() => {
                                                        SetVisitorTypeId(item?.tourist_type_id);
                                                        setIsEdit(prev => ({
                                                            ...prev,
                                                            subCat:true,
                                                        }));
                                                        setVisitorSubType([{id:item?.id, visitor_sub_type:item?.visitor_sub_type }]);
                                                    }}
                                                />
                                                <AiOutlineDelete
                                                    size={22}
                                                    className="text-danger"
                                                    onClick={() => handleVisitorCatSubDel(item.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={4} className="mt-3">
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white">
                            <h6 className="mb-0">Ticket Sub Sub Type</h6>
                        </CardHeader>
                        <CardBody>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Visitor Sub Type</th>
                                        <th>Visitor Sub Sub Type</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {visitorSubSubCatList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.touristSubType?.visitor_sub_type}</td>
                                        <td>{item?.visitor_sub_sub_type}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <AiOutlineEdit
                                                size={22}
                                                className="text-warning me-3"
                                                onClick={() => {
                                                    setVisitorSubTypeId(item?.tourist_sub_type_id);
                                                    setIsEdit(prev => ({
                                                        ...prev,
                                                        subSubCat:true,
                                                    }));
                                                    setSubVisitorSubType([{ id:item?.id,sub_visitor_sub_type:item?.visitor_sub_sub_type }]);
                                                }}
                                                />
                                                <AiOutlineDelete
                                                    size={22}
                                                    className="text-danger"
                                                    onClick={() => handleVisitorCatSubSubDel(item.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Button color="success"
                onClick={handleSubmitVisitorForm}
                className="mt-3 w-100">
                Submit
            </Button>
        </div>
    );
};

export default VisitorForm;
